import { render, staticRenderFns } from "./CourseFeedback.vue?vue&type=template&id=69b97f7e&scoped=true&"
import script from "./CourseFeedback.vue?vue&type=script&lang=js&"
export * from "./CourseFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b97f7e",
  null
  
)

export default component.exports